import yup from 'core/utils/validators';
import { FIELD_REQUIRED } from 'const';

const { object, string, number } = yup;

export const CalculatorConditionsFormSchema = () => {
  return object().shape({
    principal: number(),
    tenor: number(),
    product_id: number(),

    loan_purpose: string().required(FIELD_REQUIRED),
    promo_code: string(),
  });
};
